import gql from 'graphql-tag'

export const GetSkills = gql`
	query skillCollection($key: String!) {
		skillCollection(
			filter: { key: { startsWith: $key } }
			first: 25
			orderBy: { title: AscNullsLast }
		) {
			edges {
				node {
					id
					title
				}
			}
		}
	}
`;
